import { defineMessages } from 'react-intl';

export const SyncMenu = defineMessages({
  synchronisationOfInstallations: {
    id: 'app.SyncMenu.synchronisationOfInstallations',
    defaultMessage: 'Synchronizace instalací',
  },
  synchronisationOfPasports: {
    id: 'app.SyncMenu.synchronisationOfPasports',
    defaultMessage: 'Synchronizace pasportů',
  },
  synchronisationOfExchanges: {
    id: 'app.SyncMenu.synchronisationOfExchanges',
    defaultMessage: 'Synchronizace výměn',
  },
  settings: {
    id: 'app.common.settings',
    defaultMessage: 'Nastavení',
  },
  logout: {
    id: 'app.common.logout',
    defaultMessage: 'Odhlášení',
  },
});
